import type { Category, CategoryStore } from "./types";

// Same 10 defaults seeded by supabase/migrations/0002_seed_taxonomy.sql. The
// id is a deterministic string (not a uuid) so that across a fresh browser
// session the same category resolves to the same id in localStorage links.
const DEFAULT_CATEGORIES: Category[] = [
  { id: "cat_revenue", code: "revenue", label: "Revenue" },
  { id: "cat_contractor", code: "contractor", label: "Contractor" },
  { id: "cat_software", code: "software", label: "Software" },
  { id: "cat_marketing", code: "marketing", label: "Marketing" },
  { id: "cat_travel", code: "travel", label: "Travel" },
  { id: "cat_meals", code: "meals", label: "Meals" },
  { id: "cat_entertainment", code: "entertainment", label: "Entertainment" },
  { id: "cat_office", code: "office", label: "Office" },
  { id: "cat_payroll_related", code: "payroll_related", label: "Payroll Related" },
  { id: "cat_transfer", code: "transfer", label: "Transfer" },
  { id: "cat_uncategorized", code: "uncategorized", label: "Uncategorized" },
];

export function createLocalStorageCategoryStore(): CategoryStore {
  const listeners = new Set<() => void>();

  // Cached stable snapshot. Categories are static in the local fallback, but
  // we still expose a subscribe API so the hook contract matches the
  // Supabase store.
  const snapshot: Category[] = DEFAULT_CATEGORIES;

  return {
    list(): Category[] {
      return snapshot;
    },
    subscribe(listener: () => void): () => void {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
    async refresh(): Promise<void> {
      // The localStorage fallback is always pre-populated with the default
      // catalog, so there is nothing to reload. Kept for API parity with the
      // Supabase store.
      return;
    },
  };
}
